import React from 'react';

import { connect } from 'react-redux';

import { Actions, AppState, store, IPageState } from '../../appredux';


import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';

import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';

import './DataGrid.css';
import theme from '../../themes';
import { IconButton, Tooltip } from '@material-ui/core';
import HistorySharpIcon from '@material-ui/icons/HistorySharp';
import { CellProps } from '@inovua/reactdatagrid-community/Layout/ColumnLayout/Cell/CellProps';
import { VatTableRow } from '../../api';

//PM 2021-10-21
//wstrzykniecie tylko uzywanych pol z magazynu danych
//usuniecie ladowanie
interface TabelaStatusProps extends WithStyles<typeof styles> {
    page: IPageState,
    tableBody: VatTableRow[],
    //historiaMenu: SerwisMenu[],
    //serwisMenuItem: number,
    //selectedSerwisStatus: SerwisStatus
}

//PM 2021-10-21
//wstrzykniecie tylko uzywanych pol z magazynu danych
//usuniecie ladowanie
interface TabelaStatusState {
    ukryteKolumny: string[],
}

class TabelaStatus extends React.Component<TabelaStatusProps, TabelaStatusState>  {

    //PM 2021-09-17
    constructor(props: TabelaStatusProps) {
        super(props, {});
        this.state = {
            ukryteKolumny: [],
        }
    }

    //PM 2021-10-25
    //podlaczenie do API
    // selectStatusHistoria = async (aSerwisStatus: SerwisStatus) => {
    //     let historiaMenu = this.props.historiaMenu

    //     historiaMenu.push(this.props.serwisMenuItem)
    //     await store.dispatch(Actions.pageState.selectStatusHistoria(aSerwisStatus, historiaMenu, SerwisMenu.statusHistoria, aSerwisStatus.data.split(' ')[0]));
    //     //await this.setLadowanie()
    //     //await store.dispatch(Actions.pageState.setSerwisStatusHistoriaTablica(serwisStatusHistoria));
    //     //await this.resetLadowanie()
    // }

    //PM 2021-10-20
    dajFontAkcjaOpis = () => {
        if (window.innerWidth <= 1366)
            return '6px';
        else if (window.innerWidth <= 1600)
            return '9px';
        else
            return '10px';
    }

    //PM 2021-10-20
    dajFontOpis = () => {
        if (window.innerWidth <= 600)
            return '9px';
        else if (window.innerWidth <= 1366)
            return '10px';
        else
            return '12px';
    }

    //PM 2021-10-25
    //podlaczenie do API
    cellRender = ({ value, data, cellProps }: any) => {
        const { classes } = this.props;
        //const dziala = data.status === '1'
        //let color = dziala ? theme.palette.primary.main : theme.palette.error.main
        let color = theme.palette.primary.main 

        if (cellProps.name.includes('iloscPorazka') && Number(value) > 0) {
            color = theme.palette.error.main
        }

        const fontWeight = cellProps.name === 'brutto' ? 'bold' : 'normal';

         if (cellProps.columnIndex === 0) {
            return (
                <div >
                    {' '}
                    {/* {lastPage ? <LastPageIcon style={{ color: color }} /> : null} */}
                </div>
            )
        } else if (cellProps.columnIndex === 7 - this.state.ukryteKolumny.length) {
            return (
                <div>
                    <Tooltip title="kto historia">
                        <IconButton  className={classes.padding1}>
                            <HistorySharpIcon style={{ color: color }} fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        } else if (cellProps.columnIndex > 4 && cellProps.columnIndex < 20) {
            return (
                <div >
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight }}
                        className={`${classes.cell} ${classes.preLine}`}
                    >
                        {String(value).includes(' ') ? String(value).split(' ')[0] : value}
                    </Typography>
                </div>
            )
        } else if (cellProps.columnIndex === 3) {
            return (
                <div >
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight }}
                        className={`${classes.cell} ${classes.preLine}`}
                    >
                        {value}
                    </Typography>
                </div>
            )
        } else if (cellProps.columnIndex === 1) {
            return (
                <div >
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight }}
                        className={`${classes.cell}  ${classes.preLine} ${classes.breakAll}`}
                    >
                        {value}
                    </Typography>
                </div>
            )
        } else if (cellProps.columnIndex === 4) {
            return (
                <div >
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight }}
                        className={`${classes.cell}  ${classes.preLine} ${classes.breakAll}`}
                    >
                        {value}
                    </Typography>
                </div>
            )
        } else if (cellProps.columnIndex === 2) {
            return (
                <div >
                    <Typography
                        variant='body2'
                        style={{ color: color, fontWeight: fontWeight }}
                        className={`${classes.cell} ${classes.preLine} ${classes.breakAll}`}
                    >
                        {value}
                        {/* {String(value).replaceAll('.', '.\n')} */}
                    </Typography>
                </div>
            )
        }
    };

    headerRender = (value: string,) => {
        return (cellProps: CellProps) => {
            const { classes } = this.props;
            let hide = true

            if (cellProps.computedAbsoluteIndex == 0 || cellProps.name == "HIS") {
                hide = false;
            }

            return (
                <div className={`${classes.tableHeadline}`} style={value == "" ? { height: "50px", marginLeft: "-4px", display: "flex" } : {}} onClick={() => { hide ? this.hideColumn((cellProps.name || "")) : this.showColumns() }}>
                    <p>{value}</p>
                </div>
            )
        }
    };

    //PM 2021-05-05
    // customCellStyle = (cellProps: CellProps) => {
    //     const { data } = cellProps;

    //     return cellProps.rowIndex === this.props.tableBody.length - 1 ? { borderBottom: 0 } : {}
    // };

    hideColumn = (n: string) => {
        let kolumny = this.state.ukryteKolumny
        kolumny.push(n)
        this.setState({ ukryteKolumny: kolumny })
    }

    showColumns = () => {
        this.setState({ ukryteKolumny: [] })
    }

    //PM 2021-10-25
    //podlaczenie do API
    customCellStyle = (cellProps: CellProps) => {
        let style: React.CSSProperties = {}

        const borderlessColumns = ['iloscSukces', 'iloscPorazka', 'iloscSukces1', 'iloscPorazka1', 'iloscSukces2', 'iloscPorazka2', 'iloscSukces3', 'iloscPorazka3', 'iloscSukces4', 'iloscPorazka4',]
        const greenBackground = ['asortNazwa', 'ilosc' ]
        const whiteBackground = [ "jm", "brutto"  ]

        if (cellProps.rowIndex === this.props.tableBody.length - 1)
            style = { ...style, borderBottom: 0 }
        //if (borderlessColumns.includes(cellProps.name || ""))
        //    style = { ...style, borderLeft: 'none' }
        if (greenBackground.includes(cellProps.name || ""))
            style = { ...style, background: 'rgb(245, 255, 245)' }
        if (whiteBackground.includes(cellProps.name || ""))
            style = { ...style, background: 'rgb(255, 255, 255)' }

        return style
    };

    //PM 2021-10-25
    //podlaczenie do API
    render() {
        const classes = this.props.classes;

        let columns = [
            {
                name: 'OSTATNIA_STRONA', header: this.headerRender(''), maxWidth: 7.5, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { borderLeft: "0", height: '50px' }, className: `${classes.tableHeadline}` },
                // onRender: (cellProps: any, { data }: any) => {
                //     const dziala = data.STATUS === 1
                //     const color = dziala ? '#e65100' : theme.palette.error.main
                //     const lastPage =
                //         this.props.selectedSerwisStatus.hotelId === data.HOTEL_ID
                //         && this.props.selectedSerwisStatus.adresIp === data.ADRES_IP

                //     cellProps.style.background = lastPage ? color : 'inherit'
                // },
                style: this.customCellStyle,
                cellProps: { style: { padding: "0", } },
            },
            {
                name: 'dokLp', header: this.headerRender('lp'), maxWidth: 40, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
                cellProps: { style: { padding: "8", } },
            },
            {
                name: 'asortNazwa', header: this.headerRender('nazwa'), defaultFlex: 3, minWidth: 150, render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
            },
            {
                name: 'jm', header: this.headerRender('jm'), defaultFlex: 1, minWidth: 60, maxWidth: 120, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
                cellProps: { style: { padding: "8px", } },
            },
            {
                name: 'ilosc', header: this.headerRender('ilość'), defaultFlex: 1, minWidth: 60, maxWidth: 120, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
                cellProps: { style: { padding: "8px", } },
            },
            {
                name: 'brutto', header: this.headerRender('brutto'), defaultFlex: 1, minWidth: 60, maxWidth: 120, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
                headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
                style: this.customCellStyle,
                cellProps: { style: { padding: "8px", } },
            },
            // {
            //     name: 'netto', header: this.headerRender('netto'), defaultFlex: 1, minWidth: 75, maxWidth: 120, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
            //     headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
            //     style: this.customCellStyle,
            //     cellProps: { style: { padding: "8px", } },
            // },
            // {
            //     name: 'HIS', header: this.headerRender('his'), maxWidth: 50, textAlign: 'center' as 'center', render: this.cellRender, draggable: false,
            //     headerProps: { style: { height: '50px' }, className: `${classes.tableHeadline}` },
            //     style: this.customCellStyle,
            //     cellProps: { style: { padding: 0 } },
            // },
        ];

        //ukrycie klikniętych kolumn
        this.state.ukryteKolumny.forEach((nazwaKolumny: string) => {
            columns = columns.filter(col => col.name !== nazwaKolumny)
        })

        // const gridStyle = {
        //     minHeight: (this.props.tableBody.length * 50) + 50 + 1, border: "0", fontSize: "12px"
        // };
        const gridStyle = {
            minHeight:  this.props.tableBody.length * 52 + 60 + 1, border: "0", fontSize: "12px"
        };

        return (
                <ReactDataGrid
                    columns={columns}
                    dataSource={this.props.tableBody}

                    //onRowClick={this.selectRow}
                    activeIndex={-1}

                    showZebraRows//={false}
                    showColumnMenuTool={false}
                    sortable={false}
                    resizable={false}
                    showHoverRows={false}
                    //showCellBorders={"horizontal"}

                    style={gridStyle}
                    //rowStyle={this.rowStyle}


                    // @ts-ignore
                    //rowHeight={null}
                    rowHeight={52}
                    // pagination
                    // limit={this.state.rowsPerPage}
                    // skip={this.state.skip}
                />
        );
    }
}

const styles = (theme: Theme) => ({
    cell: {
        fontSize: "12px"
    },
    tableHeadline: {
        color: "seagreen",
        fontWeight: 'bold' as 'bold',
        backgroundColor: "rgb(247, 247, 247)",
        fontFamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        fontSize: "0.875rem",
        minWidth: "7.5px",
        margin: "auto",
        width: "-webkit-fill-available",
        cursor: "pointer"
    },
    margin: {
        //margin: theme.spacing(2) 
        margin: "auto"
    },
    preLine: {
        whiteSpace: 'pre-line' as 'pre-line'
    },
    breakAll: {
        wordBreak: 'break-all' as 'break-all'
    },
    padding1: {
        padding: '1px'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(TabelaStatus));

